import { Component, h, Host, Prop } from "@stencil/core";

/**
 * @slot - The content of the location selection accordion
 */
@Component({
    tag: "ux-iws-location-selection",
    styleUrl: "location-selection.scss",
    shadow: false,
})
export class LocationSelection {
    /** the label that is displayed on top of the component */
    @Prop() topLabel: string;

    /** Name of the current Country */
    @Prop() countryName: string;

    /** label of button */
    @Prop() buttonLabel: string;

    render() {
        return (
            <Host>
                <div class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase">
                    {this.topLabel}
                </div>
                <ux-accordion
                    active-title-class="--"
                    class="ux-iws-location-selection__selection-accordion"
                >
                    <div slot="title">
                        <h2 class="headline-big">{this.countryName}</h2>
                        <button type="button" class="ux-button ux-u-ml-xs">
                            <ux-icon
                                class="ux-u-mr-xxxs ux-color-success"
                                size-s="23"
                                name="globe-coordinates"
                                weight="light"
                            ></ux-icon>
                            {this.buttonLabel}
                        </button>
                    </div>
                    <div class="ux-iws-location-selection__locations">
                        <slot />
                    </div>
                </ux-accordion>
            </Host>
        );
    }
}
